module.exports = __webpack_public_path__ + "static/Moments-4e2a51e8eeeb5e5ea9eec1551f54998a.gif";